import React, { useState } from 'react';
import Base from '../base';
import CriticalPlatesForm from '../../components/forms/critical_plates/form.critical_plates';
import { Row, Col, Button, Form } from '@themesberg/react-bootstrap';
import { get } from '../../services/back.service';
import ListTables from '../../components/shared/tables';
import ModalShowImagesCritical from '../../components/forms/critical_plates/modal.images';

function CriticalPlates() {
  const [showForm, setShowForm] = useState(false);
  const [showButtonForm, setShowButtonForm] = useState(false);
  const [plate, setPlate] = useState('');
  const [msgTable, setMsgTable] = useState('');
  const [listReports, setListReports] = useState([]);

  const viewDetail = (row) => {
    return (
      <ModalShowImagesCritical id={row.id_c} />
    );
  };


  const validPlate = async (e) => {
    e.preventDefault();
    if (plate !== '') {
      const respo = await get('/critical/search/' + plate);
      if (respo.success) {
        setListReports(respo.data);
      } else {
        setMsgTable(respo.message);
      }
      setShowButtonForm(true);
      setShowForm(false)
    }
  }
  const addTmpLog = (info) => {
    const tmpInfo = Array.from(listReports);
    tmpInfo.push(info);
    setListReports(tmpInfo);
  }

  return (
    <Base>
      <Row>
        <Col>
          <Form id='form_plate' onSubmit={(e) => validPlate(e)}>
            <Row className='mt-2'>
              <Col>
                <Form.Label htmlFor="nombre">PLACA</Form.Label>
                <Form.Control
                  name="plate"
                  value={plate}
                  onChange={({ target }) => { setPlate(target.value); setShowForm(false); setShowButtonForm(false); setListReports([]) }}
                  type="text"
                  className="fw-bold text-uppercase"
                  minLength={6}
                  maxLength={6}
                  required
                />
              </Col>
            </Row>
            <Row className='mt-2'>
              <Col>
                <Button type="submit">Buscar</Button>
              </Col>
              {showButtonForm &&
                <Col>
                  <Button onClick={() => setShowForm(true)}>Agregar Novedad</Button>
                </Col>}
            </Row>
          </Form>
          {showForm && <Row className='mt-2'><CriticalPlatesForm plate={plate} addTmpLog={addTmpLog} /></Row>}
        </Col>
        <Col>
          <ListTables
            data={listReports}
            editar={viewDetail}
            messageWd={msgTable}
            hideFirst={false}
          />
        </Col>
      </Row>
    </Base>
  );
}

export default CriticalPlates;
